import { KalturaESearchEntryResponse } from "kaltura-typescript-client/api/types/KalturaESearchEntryResponse";
import styled from "@emotion/styled";
import { useState } from "react";
import { KalturaESearchEntryResult } from "kaltura-typescript-client/api/types/KalturaESearchEntryResult";
import { Pagination } from "@kaltura/ds-react-components";
import { MediaCard } from "@kaltura/mediaspace-shared-media-card";
import { Stack } from "@kaltura/mediaspace-shared-styled";
import { SearchResultsInnerComponentProps } from "../../search-results-container/types";

export interface SearchResultsProps extends SearchResultsInnerComponentProps {
    entryResults: KalturaESearchEntryResponse;
}

export const SearchResults = (props: SearchResultsProps) => {
    const { entryResults, page = 1, onPageChange, pageSize, onEntryShowMore, isWideLayout, isTextSearch } = props;
    const [activeEntry, setActiveEntry] = useState<string>();

    const pageCount = Math.ceil(entryResults.totalCount / pageSize);

    const handleMore = (searchResult: KalturaESearchEntryResult) => {
        setActiveEntry(searchResult.object.id);
        onEntryShowMore(searchResult);
    };

    return (
        <Stack direction={"column"} gap={2}>
            {entryResults.totalCount > 0 && (
                <StyledUl>
                    {entryResults.objects.map((entry) => (
                        <StyledLi key={entry.object.id}>
                            <MediaCard
                                data={entry}
                                mode={isTextSearch ? "search" : "list"}
                                onMore={handleMore}
                                active={entry.object.id === activeEntry && !isWideLayout}
                            />
                        </StyledLi>
                    ))}
                </StyledUl>
            )}

            {pageCount > 1 && (
                <Pagination count={pageCount} page={page} onChange={(_ev, value) => onPageChange(value)} />
            )}
        </Stack>
    );
};

const StyledUl = styled("ul")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
    padding: 0,
    margin: 0,
}));

const StyledLi = styled("li")({
    display: "block",
});
